import { useAuth } from '@/contexts/AuthContext';

/**
 * Hook to check if multi-team feature is enabled for the current shop.
 * Uses shop.multi_team_enabled AND shop.tier === 'ENTERPRISE' as the source of truth.
 * No addons check - the database is the single source of truth.
 */
export function useMultiTeam() {
  const { activeShop, isShopDataLoading } = useAuth();

  const isMultiTeamEnabled = 
    activeShop?.tier === 'ENTERPRISE' && 
    (activeShop as any)?.multi_team_enabled === true;

  return {
    isMultiTeamEnabled,
    isLoading: isShopDataLoading,
    shop: activeShop,
  };
}
